import { toRelativeDateString as toRelativeDateStringBase } from "@forento/core/utilities/date"

export function toRelativeDateString(date: Date, style?: Intl.RelativeTimeFormatStyle): string {
	return toRelativeDateStringBase(date, "en", style)
}
